/**
 * Append Sanity CDN transform params to an image URL so the browser downloads a
 * right-sized, modern-format image instead of the full-resolution original.
 *
 * Sanity's image CDN resizes/compresses/reformats on the fly via query params:
 *   ?w=600&h=400&fit=crop&auto=format  -> ~30 KB WebP instead of a 7 MB PNG.
 *
 * Only touches cdn.sanity.io URLs; local/imported images pass through unchanged.
 *
 * @param {string} url   the image URL (from Sanity asset->url, or a local import)
 * @param {object} opts  { w, h, q, fit } sizing options
 */
export function sanityImg(url, { w = 800, h, q = 70, fit = "crop" } = {}) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("cdn.sanity.io")) return url;
  const sep = url.includes("?") ? "&" : "?";
  const parts = [`w=${w}`];
  if (h) parts.push(`h=${h}`);
  parts.push(`fit=${fit}`, "auto=format", `q=${q}`);
  return `${url}${sep}${parts.join("&")}`;
}

export default sanityImg;
